askSchoolSpecificQuestions.classy.controller({
    name: 'AskSchoolSpecificQuestionsModalController',
    inject: ['$scope', 'authServiceFactory', 'index', 'item', 'StandardModalCudFactory', '$modalInstance', 'AskSchoolSpecificQuestionsModelService'],
    init: function()
    {
        this.$.modalCud = new this.StandardModalCudFactory(this.AskSchoolSpecificQuestionsModelService,
           this.authServiceFactory.getAuth().schoolID, this.item, this, [], this.index, this.$modalInstance);

        if (this.index == undefined) {
            this.$.index = this.AskSchoolSpecificQuestionsModelService.data.length-1;
        }
        if (this.$.item.Q_type==='4') {
            this.yesno();
        }
    },
    yesno: function() 
    {
        if (this.$.item.Yes_text === "True") {
            this.$.item.No_text = "False";
        }
        else {
            this.$.item.No_text = "No";
        }
    },
    startSaveProcess: function(scope, instance, form) {
        if (form.$valid) {
            if (this.$.item.Q_type === "4") {
                this.yesno();
            }
            let parent = this;
            instance.options.factor  = .3;
            if (typeof this.$.item.recordID !== "undefined") { 
                this.$.item.approved = 0;
                this.AskSchoolSpecificQuestionsModelService.put(this.authServiceFactory.getAuth().schoolID, this.$.item, instance).then(() => {
                    parent.AskSchoolSpecificQuestionsModelService.resolveData();
                });
            } else {
                this.AskSchoolSpecificQuestionsModelService.post(this.authServiceFactory.getAuth().schoolID, this.$.item, instance).then(() => {
                    parent.AskSchoolSpecificQuestionsModelService.resolveData();
                });
            }
        } else {
            instance.stop(-1);
        }
    },
    startDeleteProcess: function(scope, instance, form) {
        instance.options.factor  = .3; 
        this.$.item.deleted = 1;
        this.$.item.Active = 0;
        return this.AskSchoolSpecificQuestionsModelService.put(this.authServiceFactory.getAuth().schoolID, this.$.item, instance)
    },
    dismiss: function(index)
    {

        if (typeof this.AskSchoolSpecificQuestionsModelService.data[index].recordID == 'undefined') {
            this.AskSchoolSpecificQuestionsModelService.data.pop();
        }
        this.$.$modalInstance.dismiss('cancel');
    },
    range: function(length) {
        return new Array(length);
    }
});